export default __webpack_public_path__ + "static/media/7.3ff2f071.jpg";